/* eslint-disable no-nested-ternary */ /* eslint-disable no-promise-executor-return */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ /* eslint-disable no-unused-vars */ import React, {  useState,
  useRef,
  useContext,
} from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import _ from 'lodash';
import { TextField, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import FlashContext from '../../components/contexts/FlashContext';
import MyButton from '../../components/button/MyButton';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 10,
    margin: 0,
  },
  chip: {
    margin: 10,
  },
  myTextField: {
    backgroundColor: 'none',
    boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
    border: 'none',
    color: '#717171',
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
  },
  text: {
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    color: '#717171',
  },
  input: {
    backgroundColor: '#fff',
    marginTop: 0,
  },
}));

function Filter({ chipData, setChipData, find, setPage, setOpenDialog }) {
  const { t } = useTranslation();
  const local = useLocation();
  const classes = useStyles();
  const { notifyError } = useContext(FlashContext);

  const searchRef = useRef(null);
  const [searchType, setSearchType] = useState();
  const [options, setOptions] = useState([
    {
      label: t('costCenters.filter.options.name'),
      value: 'name',
    },
    {
      label: t('costCenters.filter.options.code'),
      value: 'code',
    },
    {
      label: t('costCenters.filter.options.type'),
      value: 'type',
    },
  ]);

  const handleDelete = chipToDelete => () => {
    setOptions([
      ...options,
      { label: chipToDelete.by, value: chipToDelete.byType },
    ]);
    setChipData(chips => chips.filter(chip => chip.key !== chipToDelete.key));
  };

  const internSearch = () => {
    setPage(0);

    const inputValue = searchRef?.current?.value?.trim();

    if (searchType && inputValue !== '') {
      includeSearch(true);
    } else {
      find();
    }
  };

  const includeSearch = btn => {
    try {
      const inputValue = searchRef?.current?.value?.trim();
      if (!searchType) {
        notifyError(t('costCenters.filter.errors.addFilter'));
        return;
      }

      const newChip = {
        key: new Date().getTime(),
        label: inputValue,
        by: searchType.label,
        byType: searchType.value,
      };

      const newChipList = [...chipData, newChip];
      setChipData(newChipList);

      const newOptions = options.filter(e => e.value !== searchType.value);
      setOptions(newOptions);

      setSearchType(null);
      searchRef.current.value = '';

      if (btn) {
        find(newChipList);
      }
    } catch (e) {
      notifyError('Escolha um Tipo');
    }
    searchRef.current.value = '';
  };

  const addChip = () => {
    if (searchType) {
      includeSearch(false);
    } else {
      notifyError(t('costCenters.filter.errors.addFilter'));
    }
  };

  const teclaEnter = e => {
    if (e.key === 'Enter') {
      internSearch();
    }
  };

  return (
    <>
      <Grid
        container
        style={{
          justifyContent: 'end',
          alignItems: 'center',
          marginBottom: 30,
          marginTop: 15,
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MyButton
            style={{ marginRight: 50 }}
            onClick={() => setOpenDialog(true)}
            label={t('costCenters.filter.buttons.addCenter')}
          />
          <Grid container spacing={1} style={{ justifyContent: 'end' }}>
            <Grid item>
              <Select
                fullWidth
                onChange={setSearchType}
                value={searchType}
                classNamePrefix="select"
                placeholder={t('contract.filters.type')}
                isSearchable={false}
                options={options}
                menuPortalTarget={document.body}
                style={{ zIndex: 999 }}
              />
            </Grid>
            <Grid item style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                onKeyUpCapture={e => teclaEnter(e)}
                inputRef={searchRef}
                color="secondary"
                width="400px"
                className={classes.textField}
                fullWidth
                size="small"
                style={{ maxHeight: 10, minWidth: 300 }}
                variant="outlined"
                InputProps={{
                  className: classes.input,
                }}
              />

              <Button
                onClick={addChip}
                variant="contained"
                style={{ marginLeft: 5, marginRight: 5 }}
              >
                <AddIcon />
              </Button>
              <Button onClick={internSearch} variant="contained">
                {t('costCenters.filter.buttons.search')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>{' '}
      <Grid item xs={4} sm={6}>
        <Grid item className={classes.root}>
          {chipData.map((dt, i) => {
            let icon;

            return (
              // eslint-disable-next-line react/no-array-index-key
              <li key={i}>
                <Chip
                  icon={icon}
                  label={`${dt.by} | ${dt.label}`}
                  onDelete={handleDelete(dt)}
                  className={classes.chip}
                />
              </li>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
}

export default Filter;
